import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';
import { useCustomerStore } from './customerStore';

export const useCreditReportStore = defineStore('creditReportStore', {
	state: () => ({
		activeCreditReport: {}
	}),
	getters: {},
	actions: {
		clearCreditReportState(){
			this.activeCreditReport = {}
		},
		// getCreditReportList(params={}) {
		//   const httpStore = useHttpStore();
		//   return new Promise((resolve, reject) => {
		//     httpStore.get(`${services.attachment}attachments`, params).then((resp) => {
		//       httpStore.convertPaginationKeys(resp.data);
		// 			this.activeApprovalList = resp.data.data
		//       resolve(resp.data);
		//     }).catch(err => {
		//       _gNotif.cLog(err);
		//       reject(err);
		//     });
		//   });
		// },
		getCreditReports(params={}) {
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				httpStore.get(`${services.credit_report}credit-reports`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
					_gNotif.cLog(err);
					reject(err);
				});
			});
		},
		getCreditReport(id = null, refresh_report = false) {
			const customerStore = useCustomerStore();
			const active_credit_report_id = !_gHlp.isEmpty(id) ? id : _gHlp.getValue(customerStore.activeCustomerInv,'credit_report_id',null);
			let params = {
				refresh_report: refresh_report,
				credit_report_id: active_credit_report_id
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(active_credit_report_id)) {
					httpStore.get(`${services.credit_report}credit-report/summary`, params).then((resp) => {
						this.activeCreditReport = resp.data;
						resolve(resp.data);
					}).catch(err => {
						this.activeCreditReport = {}
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					resolve({});
				}
			});
		},
		syncLatestSasCreditReport(sas_im2u_id){
			const customerStore = useCustomerStore();
			if(_gHlp.isEmpty(sas_im2u_id))  sas_im2u_id = _gHlp.getValue(customerStore.activeCustomerInv,'sas_im2u_id',null);
			let params = {
				credit_report_cust_id: sas_im2u_id
			}
			const httpStore = useHttpStore();
			return new Promise((resolve, reject) => {
				if (!_gHlp.isEmpty(sas_im2u_id)) {
					httpStore.get(`${services.credit_report}credit-report/summary`, params).then((resp) => {
						this.activeCreditReport = resp.data;
						_gHlp.setLocalStorage('credit_report.detail', this.activeCreditReport);

						//UPDATE LATEST CREDIT REPORT ID ON LMS 
						customerStore.updateCustomer(_gHlp.getValue(customerStore.activeCustomerInv,'id',null),{credit_report_id: this.activeCreditReport.credit_report_id})
						resolve(resp.data);
					}).catch(err => {
						this.activeCreditReport = {}
						_gNotif.cLog(err);
						reject(err);
					});
				} else {
					resolve({});
				}
			});
		}
	}
})